export const REPORT_ROUTE_NAMES = {
  OVERVIEW: 'reportsOverview',
  SALES: 'reportSales',
  WEB_ANALYTICS: 'reportWebAnalytics',
  SHOW_INSIGHTS: 'reportShowInsights',
} as const
